import { render, staticRenderFns } from "./CdkFavoriteButton.vue?vue&type=template&id=249108f5&scoped=true&"
import script from "./CdkFavoriteButton.vue?vue&type=script&lang=ts&"
export * from "./CdkFavoriteButton.vue?vue&type=script&lang=ts&"
import style0 from "./CdkFavoriteButton.vue?vue&type=style&index=0&id=249108f5&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249108f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
